import { Component, forwardRef } from '@angular/core';
import { SharedUserAccessComponent } from '../../shared-components/shared-user-access/shared-user-access.component';

@Component({
  selector: 'app-organization-user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.scss'],
  imports: [forwardRef(() => SharedUserAccessComponent)],
})
export class UserAccessComponent {}
